import * as React from 'react';
import styled from 'styled-components';
import { ISortChangeEvent } from './RemoteTable.types';
// @ts-ignore
import tableArrowDownIcon from '../../assets/icons/table-arrow-down.svg';
// @ts-ignore
import tableArrowUpIcon from '../../assets/icons/table-arrow-up.svg';

const HeaderCellButton = styled.button`
  border: unset;
  margin-bottom: 12px;
  background: transparent;
`;

const HeaderCellText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.font1};
  opacity: 50%;
  display: inline-block;
`;

const SortArrowsWrapper = styled.div`
  display: inline-block;
`;

const SortArrow = styled.img<{ isDescending?: boolean }>`
  margin-left: 4px;
  transform: rotateX(
    ${({ isDescending }) => (isDescending ? '0deg' : '180deg')}
  );
  transition: all 0.5s ease-in;
`;

interface IHeaderCellProps {
  columnKey: string;
  value: string | object;
  sortDirection?: 'asc' | 'desc';
  disableSort: boolean;
  onSortChange(e: ISortChangeEvent): any;
  headerStyle?: React.CSSProperties;
}

interface IHeaderSort {
  sortDirection?: 'asc' | 'desc';
}

const HeaderSort: React.FC<IHeaderSort> = (props: IHeaderSort) => {
  const { sortDirection } = props;
  return (
    <SortArrowsWrapper>
      <SortArrow
        className="active"
        src={tableArrowDownIcon}
        alt="sort-icon-asc"
        isDescending={sortDirection === 'desc' || !sortDirection}
      />
    </SortArrowsWrapper>
  );
};

const HeaderCell: React.FC<IHeaderCellProps> = (props: IHeaderCellProps) => {
  const {
    value,
    disableSort,
    sortDirection,
    columnKey,
    onSortChange,
    headerStyle
  } = props;
  return (
    <th style={headerStyle}>
      <HeaderCellButton
        disabled={disableSort}
        onClick={e => {
          e.preventDefault();
          if (onSortChange && sortDirection === 'asc') {
            onSortChange({ sortDirection: 'desc', key: columnKey });
          } else if (
            (onSortChange && sortDirection === 'desc') ||
            !sortDirection
          ) {
            onSortChange({ sortDirection: 'asc', key: columnKey });
          }
        }}
        type="button"
      >
        <div className="cell-text-container">
          <HeaderCellText
            className={`${
              sortDirection === 'asc' || sortDirection === 'desc'
                ? 'header-cell-text-active'
                : ''
            }`}
          >
            {value}
          </HeaderCellText>
          {!disableSort && <HeaderSort sortDirection={sortDirection} />}
        </div>
      </HeaderCellButton>
    </th>
  );
};

export default HeaderCell;
